export default {
  common: {
    search: 'Hľadať',
    selected: 'Vybrané',
  },
  actions: {
    clear: 'Vymazať',
  },
};
